export enum SLOT_TYPES {
	CLEARED = 0,
	IN_PROGRESS = 1,
	READY = 2,
}
